import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink } from '../../../components';

import './Card13.scss';

class Card13 extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>#SeLigaNaFraude alerta sobre golpes financeiros - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home card13-home page-gradient page-gradient--yellow bg-gray" ref="card13-home">
          <section className="iniciativas-area card13-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title">#SeLigaNaFraude alerta sobre golpes financeiros</h1>
                        </div>
                        <div className="card__content__body">
                          <div className="row flex">
                            <div className="col-6">
                              <p>
                                Com conteúdos interativos sobre como se proteger de golpes e fraudes financeiras, o
                                portal{' '}
                                <a href="https://seliganafraude.anbima.com.br/" target="_blank">
                                  Se Liga na Fraude
                                </a>{' '}
                                entrou no ar em outubro com o objetivo oferecer informações e alertar sobre os vários
                                tipos de armadilhas e golpes disponíveis na internet.
                              </p>
                              <p>
                                Desenvolvida em parceria com a CVM, a iniciativa é resultado de um convênio que
                                assinamos com o órgão regulador em agosto para a cooperação em projetos e estudos de
                                educação financeira.
                              </p>
                            </div>
                            <div className="col-6 img-center h-img">
                              <img src={images.iniciativas.card13.img1} className="img1" />
                              <img src={images.iniciativas.card13.anima1} className="anima1" />
                              <img src={images.iniciativas.card13.anima2} className="anima2" />
                            </div>
                          </div>

                          <div className="col-12">
                            <p>
                              O site explica as características das principais fraudes aplicadas no país, como:
                              pirâmides financeiras; marketing multinível; forex; esquemas com criptomoedas; e falsos
                              profissionais de investimentos. O conteúdo é gratuito, está disponível a qualquer
                              interessado e inclui materiais para divulgação, como peças para redes sociais e banners.
                            </p>
                            <p>
                              Este{' '}
                              <a
                                href="http://conteudo.cvm.gov.br/export/sites/cvm/convenios/anexos/ANBIMA_EducacaoFinanceira.pdf"
                                target="_blank"
                              >
                                acordo
                              </a>{' '}
                              com a CVM tem prazo de cinco anos e prevê a colaboração em pesquisas e estudos, na
                              realização de atividades como cursos e palestras e no desenvolvimento e disseminação de
                              materiais educacionais.
                            </p>
                            <p>
                              Entre os materiais criados como parte da parceria está um suposto{' '}
                              <a href="https://www.mvcfinvestimentos.com.br/" target="_blank">
                                site de uma empresa de investimentos
                              </a>
                              , a{' '}
                              <a href="https://www.mvcfinvestimentos.com.br/" target="_blank">
                                MVCF Investimentos
                              </a>
                              , que, na verdade é um site de phishing (do inglês fishing, pois pesca de maneira
                              fraudulenta informações como contas bancárias e senhas dos usuários). O endereço simula um
                              portal de investimento, com promessas de retorno rápido e garantido. Ao clicar no botão
                              "quero investir o meu dinheiro", o investidor é lavado para uma página de alerta
                              explicando que ele quase caiu numa fraude, e recebe uma série de informações sobre fraudes
                              financeiras. Em seis meses, o site teve mais de 20 mil acessos e uma taxa de conversão de
                              20% - mais de 4 mil pessoas chegaram no botão de "quero investir", mostrando o quanto são
                              vulneráveis a crimes cibernéticos.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Card13 };
